// extracted by mini-css-extract-plugin
module.exports = {"container":"LegalPolicyContent_container__QDaJx","section":"LegalPolicyContent_section__B0OHO","contentList":"LegalPolicyContent_contentList__eHu5Y"};